import { revertPosOfCmp } from "./Functions";

/* eslint-disable array-callback-return */
export const Overlap = (doorArray, id, width, height, positionX, positionY, componentDistance, wallName) => {
    const overlapArray = [];

    revertPosOfCmp(doorArray, wallName)

    doorArray.map((item) => {
        if (Math.abs(item.positionX - positionX) < item.width / 2 + width / 2 + componentDistance && Math.abs(item.positionY - positionY) < item.height / 2 + height / 2 + componentDistance) {
            overlapArray.push(item.uniqueId);
        }

        return null;
    })

    if (overlapArray.length > 0) {
        overlapArray.push(id);
    }
    
    revertPosOfCmp(doorArray, wallName)

    return overlapArray;
}

export const CupolaOverlap = (cupolaArr, id, length, positionZ, componentDistance) => {
    const overlapArray = [];

    cupolaArr.map(item => {
        if (Math.abs(item.positionZ - positionZ) < item.width / 2 + length / 2 + componentDistance) {
            overlapArray.push(item.uniqueId)
        }

        return null;
    })
    
    if (overlapArray.length > 0) {
        overlapArray.push(id);
    }
    
    return overlapArray;
}

export const TrussOverlap = (trussPosArr, wallName, doorPosX, doorWidth, buildingType) => {
    let idArr = [];
    let overlapArray;

    const trussWidth = 0.3;
    
    if (buildingType === 'center') {
        trussPosArr.map((item, index) => {
            if (wallName === 'c_b_l_w' || wallName === 'c_b_l_s_w') {
                if (Math.abs(item - doorPosX) <= trussWidth / 2 + doorWidth / 2) {
                    idArr.push(index);
                }
            } else if (wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w') {
                if (Math.abs(item - (-doorPosX)) <= trussWidth / 2 + doorWidth / 2) {
                    idArr.push(index);
                }
            } 
            
            return null;
        })

    } else if (buildingType === 'leftlean') {
        if (wallName === 'L_L_L_W' || wallName === "L_L_L_S_W") {
            (trussPosArr.leftLeanTo.sort((a, b) => a - b)).map((item, index) => {
                if (Math.abs(item - doorPosX) <= trussWidth / 2 + doorWidth / 2) {
                    idArr.push(index);
                }
            })
        }  
    } else if (buildingType === 'rightlean') {
        
        if (wallName === 'R_L_R_W' || wallName === "R_L_R_S_W") {
            (trussPosArr.rightLeanTo.sort((a, b) => a - b)).map((item, index) => {
                if (Math.abs(item - doorPosX) <= trussWidth / 2 + doorWidth / 2) {
                    idArr.push(index);
                }
            })
        }
    } else if (buildingType === 'frontlean') {
        if (wallName === 'F_L_F_W' || wallName === "F_L_F_S_W") {
            (trussPosArr.frontLeanTo.sort((a, b) => a - b)).map((item, index) => {
                if (Math.abs(item - doorPosX) <= trussWidth / 2 + doorWidth / 2) {
                    idArr.push(index);
                }
            })
        }
    } else if (buildingType === 'backlean') {
        if (wallName === 'B_L_S_W' || wallName === "B_L_S_S_W") {
            (trussPosArr.backLeanTo.sort((a, b) => a - b)).map((item, index) => {
                if (Math.abs(item - doorPosX) <= trussWidth / 2 + doorWidth / 2) {
                    idArr.push(index);
                }
            })
        }
    }
    
    overlapArray = {
        idArr,
        buildingType,
    };

    return overlapArray;
}